module.exports = __webpack_public_path__ + "static/orcestra-689900530353fdc4b5ba56eba0c8d4c8.png";